/**
 * Приводит значение поля формы к числу; пустое или нечисловое значение — `undefined`.
 * Числовые поля React Hook Form отдают значение строкой, поэтому приведение нужно явное.
 */
export const toNumberOrUndefined = (value: unknown): number | undefined => {
  if (value === undefined || value === null || value === '') return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};
